/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

/**
 * Validator declaration
 */
export class ValidatorDeclarationError extends Error {
	public validatorName: string;
	public errorMessage: string;

	public constructor(name: string, message: string) {
		super(`Can't create validator '${name}' : ${message}`);

		this.validatorName = name;
		this.errorMessage = message;
	}
}
